import { pgTable, uuid, text, timestamp, integer, boolean, jsonb, pgEnum } from "drizzle-orm/pg-core";
import { tenants } from "./tenants";

export const matchTypeEnum = pgEnum("match_type", ["exact", "prefix", "regex"]);
export const deviceEnum = pgEnum("device_type", ["pc", "sp", "tablet"]);

export const sites = pgTable("sites", {
  id: uuid("id").primaryKey().defaultRandom(),
  tenantId: uuid("tenant_id").notNull().references(() => tenants.id, { onDelete: "cascade" }),
  name: text("name").notNull(),
  domain: text("domain").notNull(),
  siteKey: text("site_key").notNull().unique(),
  createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
});

export const pages = pgTable("pages", {
  id: uuid("id").primaryKey().defaultRandom(),
  siteId: uuid("site_id").notNull().references(() => sites.id, { onDelete: "cascade" }),
  name: text("name").notNull(),
  urlPattern: text("url_pattern").notNull(),
  matchType: matchTypeEnum("match_type").notNull().default("exact"),
});

export const sections = pgTable("sections", {
  id: uuid("id").primaryKey().defaultRandom(),
  pageId: uuid("page_id").notNull().references(() => pages.id, { onDelete: "cascade" }),
  key: text("key").notNull(),
  name: text("name").notNull(),
  selector: text("selector").notNull(),
  sortOrder: integer("sort_order").notNull().default(0),
  isCta: boolean("is_cta").notNull().default(false),
});

export const funnels = pgTable("funnels", {
  id: uuid("id").primaryKey().defaultRandom(),
  pageId: uuid("page_id").notNull().references(() => pages.id, { onDelete: "cascade" }),
  name: text("name").notNull(),
  steps: jsonb("steps").notNull(), // ステップ配列: sections/goals参照
});

export const snapshots = pgTable("snapshots", {
  id: uuid("id").primaryKey().defaultRandom(),
  pageId: uuid("page_id").notNull().references(() => pages.id, { onDelete: "cascade" }),
  device: deviceEnum("device").notNull(),
  width: integer("width").notNull(),
  r2Key: text("r2_key").notNull(),
  domHash: text("dom_hash").notNull(),
  capturedAt: timestamp("captured_at", { withTimezone: true }).notNull().defaultNow(),
});
